import constantCreator from 'utils/constantCreator';
import api from 'utils/api';

const define = constantCreator('mail');
const SEND_MAIL = define('SEND_MAIL', true);

const initialState = {

};

export default (state = initialState, action) => {
  switch (action.type) {
    default: return state;
  }
};

export const actions = {
  sendMail: (type, id, template, data = {}) => ({
    type: SEND_MAIL,
    promise: api.post(`/mail/${type}/${id}/${template}`, data),
    success: 'Email has been sent',
    error: 'Unable to send email'
  })
};



// WEBPACK FOOTER //
// ./src/ducks/mail.js